import * as Yup from "yup";
import getForm from "./form";

const {
  formField: { country, startPeriodYear, lastPeriodYear, periodYearStep },
} = getForm();

const validations = Yup.object().shape({
  [country.name]: Yup.string(),
  [startPeriodYear.name]: Yup.number().required(startPeriodYear.errorMsg),
  [lastPeriodYear.name]: Yup.number()
    .min(1909, lastPeriodYear.errorMinMaxMsg)
    .max(2049, lastPeriodYear.errorMinMaxMsg)
    .required(lastPeriodYear.errorMsg),
  [periodYearStep.name]: Yup.number()
    .min(5, periodYearStep.errorMinMaxMsg)
    .max(50, periodYearStep.errorMinMaxMsg)
    .required(periodYearStep.errorMsg),
});

export default validations;
